import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiCommControlLookup extends Layout {
    sourceEdiCommControlLookup: DataSource;
    table1: Table;
}
